__turbopack_context__.v({
  "buttonContainer": "Subscribed-module__4lhBjq__buttonContainer",
  "disclaimerContainer": "Subscribed-module__4lhBjq__disclaimerContainer",
  "disclaimerContainerLandscape": "Subscribed-module__4lhBjq__disclaimerContainerLandscape",
  "spinnerContainer": "Subscribed-module__4lhBjq__spinnerContainer",
  "unsubscribeButtonContainer": "Subscribed-module__4lhBjq__unsubscribeButtonContainer",
});
